import { z } from "zod";

export type ValidationErrors = Record<string, string>;

/**
 * Validates data with a Zod schema and returns structured field-level errors.
 * Converts Zod's array-based error format into a flat object where keys are
 * field paths and values are error messages, making it easy for UI components
 * to display field-specific validation errors.
 */
export function structuredValidate<T>(
	schema: z.ZodSchema<T>,
	data: unknown,
): { success: true; data: T } | { success: false; errors: ValidationErrors } {
	const result = schema.safeParse(data);

	if (result.success) {
		return { success: true, data: result.data };
	}

	const fieldErrors: ValidationErrors = {};
	result.error.issues.forEach((err) => {
		const fieldPath = err.path.join(".");
		fieldErrors[fieldPath] = err.message;
	});

	return { success: false, errors: fieldErrors };
}
